import React, { useState, useEffect } from "react";
import { Menu, Typography, Table, Skeleton, Progress } from "antd";

import { postData,getData } from '../../config/api-connect';
import * as Styled from './style.js';

import PercentageBadge from '../../components/percentageBadge'
import moment from 'moment';
import { ArrowRightOutlined } from '@ant-design/icons';

const AdultSummary = ({ venue_id, sport, game_type_id, month, year }) => {
  const [currentTab, setCurrentTab] = useState("summary");
  const [loading, setLoading] = useState(false)
  const [summaryData, setSummaryData] = useState([])
  const [header, setHeader] = useState([])
  const [customerData, setCustomerData] = useState([])
  const [totalRevenue, setTotalRevenue] = useState('')
  
  const handleClick = (e) => {
    setCurrentTab(e.key);
  };

  useEffect(() => {
    if(currentTab == 'summary'){
      getSummary()
    }
    else if(currentTab == 'list'){
      getCustomerList()
    }    
  }, [currentTab,month,year,sport]);

  const  getCustomerList= () => {
    setLoading(true)
    var monthYear = year + '-' + month
    getData(`/eagleeye/getTableData/?report_id=76387&venue_id=${venue_id}&date=${monthYear}&game_type_id=${sport}`)
    .then(response =>{
      setHeader(response.headers)
      setCustomerData(response.data)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const getSummary = () => {
    setLoading(true)
    getData(`/business/get_adult_summary_details/?venue_id=${venue_id}&&month=${month}&year=${year}&game_name=${sport}`)
    .then(response =>{
      setSummaryData(response.result)
      setTotalRevenue(response.total_revenue)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const columns = header.map((header, index) => ({
    title: header,
    dataIndex: index.toString(),
    key: header,
    align: 'center',
    sorter: (a, b) => {
      const valA = a[index];
      const valB = b[index];

      const numA = parseFloat(valA);
      const numB = parseFloat(valB);

      const isNumA = !isNaN(numA) && isFinite(valA);
      const isNumB = !isNaN(numB) && isFinite(valB);

      if (isNumA && isNumB) {
        return numA - numB;
      }

      // Fallback to string comparison
      const strA = (valA || '').toString().toLowerCase();
      const strB = (valB || '').toString().toLowerCase();
      return strA.localeCompare(strB);
    },

    render: (text) => (
        <span dangerouslySetInnerHTML={{ __html: text }} />
    )
  }));  

  const rowData = customerData.map((row, rowIndex) => {
      const rowObj = {};
      row.forEach((cell, cellIndex) => {
          rowObj[cellIndex] = cell;
      });
      return { key: rowIndex, ...rowObj };
  });

  const calculatepercent = (value) => {
    return Math.round((value / totalRevenue) * 100)
  }
  return (
    <div style={{ padding: 10 }}>
      <Menu onClick={handleClick} selectedKeys={[currentTab]} mode="horizontal">
        <Menu.Item key="summary">Summary</Menu.Item>
        <Menu.Item key="list">List</Menu.Item>
      </Menu>

      <div style={{ marginTop: '1%' }}>
        {currentTab === "summary" ? 
          loading ? 
            <Skeleton active paragraph={{ rows: 7 }} />
          : 
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between',gap: '20px' }}>
              {summaryData.map((data,index)=>(
                <Styled.CardDiv key={index} >
                                             
                  <Styled.CardHeader>  
                    <div style={{ fontSize: '20px', fontWeight: 'bold'}}>{data.game_type}</div>                              
                    <div style={{ display: 'flex',flexDirection:'column', alignItems:'center'}}>                                
                      <div style={{fontSize: '14px'}}>
                        ₹{data.revenue.toLocaleString('en-IN')}
                      </div>
                      <div style={{ fontSize: '12px'}}>
                        {data.customers} {data.customers === 1 ? 'customer' : 'customers'}
                      </div>
                    </div>                                                           
                    <Progress type="circle" percent={data.percentage} showInfo={true} strokeColor="#02475c" width={50} format={percent => <span style={{ fontWeight: 'bold' }}>{percent}%</span>}/>
                  </Styled.CardHeader>

                  <div style={{ padding: '20px'}}>
                    <Styled.ProgressHeader>
                      <div style={{ fontWeight:'bold' }}>Membership</div>
                      <div>₹{data.memberships.revenue.toLocaleString('en-IN')} - <span style={{ fontSize: '12px'}}>{data.memberships.customers} {data.memberships.customers === 1 ? 'customer' : 'customers'}</span></div>                                   
                    </Styled.ProgressHeader>
                    <Progress percent={calculatepercent(data.memberships.revenue)} showInfo={false} strokeColor="#337ab7"/>                                
                  </div>
    
                  <div style={{ padding: '20px'}}>
                    <Styled.ProgressHeader>
                      <div style={{ fontWeight:'bold' }}>Pay Per Game</div>
                      <div>₹{data.pay_per_game.revenue.toLocaleString('en-IN')} - <span style={{ fontSize: '12px'}}>{data.pay_per_game.customers} {data.pay_per_game.customers === 1 ? 'customer' : 'customers'}</span></div>
                    </Styled.ProgressHeader>
                    <Progress percent={calculatepercent(data.pay_per_game.revenue)} showInfo={false} strokeColor="#9370db"/>
                  </div>

                </Styled.CardDiv>
                ))
              }
            </div>  
         : 
          currentTab === "list" &&
            loading ? 
              <Skeleton active paragraph={{ rows: 7 }} />
            : 
              <div>
                <div className="recordCount">{rowData.length} records</div>
                <Table
                  className="drill-down-table table_container center-pagination"
                  rowKey="id"
                  columns={columns}
                  dataSource={rowData}
                  pagination={{ pageSize: 50, showSizeChanger: false }}
                />
              </div>  
        }

      </div>
    </div>

  );
};

export default AdultSummary;
